import z from "zod";

export const createUserSchema = z.object({
  email: z.string().email("Email inválido"),
  password: z.string().min(6, "Senha deve ter no mínimo 6 caracteres"),
  fullName: z.string().min(1, "Nome completo é obrigatório"),
  cpf: z
    .string()
    .optional()
    .refine((val) => val && val.length >= 11, {
      message: "CPF é obrigatório",
    }),
  phone: z
    .string()
    .optional()
    .refine((val) => val && val.length > 0, {
      message: "Telefone é obrigatório",
    }),
  street: z.string().min(1, "Rua é obrigatória"),
  number: z.string().min(1, "Número é obrigatório"),
  neighborhood: z.string().min(1, "Bairro é obrigatório"),
  city: z.string().min(1, "Cidade é obrigatória"),
  state: z
    .string()
    .min(2, "Estado é obrigatório")
    .max(2, "Estado deve ter 2 caracteres"),
  zipCode: z.string().min(8, "CEP deve ter 8 dígitos"),
  role: z.enum(["ADMIN", "AGENT", "CITIZEN", "AUDIT", "TRIAGE"]),
});

export type CreateUserFormData = z.infer<typeof createUserSchema>;

export const updateUserSchema = z.object({
  role: z.enum(["ADMIN", "AGENT", "CITIZEN", "AUDIT", "TRIAGE"]),
  isActive: z.boolean(),
  fullName: z.string().min(1, "Nome completo é obrigatório"),
  cpf: z.string().min(11, "CPF é obrigatório"),
  phone: z.string().min(1, "Telefone é obrigatório"),
  street: z.string().min(1, "Rua é obrigatória"),
  number: z.string().min(1, "Número é obrigatório"),
  neighborhood: z.string().min(1, "Bairro é obrigatório"),
  city: z.string().min(1, "Cidade é obrigatória"),
  state: z
    .string()
    .min(2, "Estado é obrigatório")
    .max(2, "Estado deve ter 2 caracteres"),
  zipCode: z.string().min(8, "CEP deve ter 8 dígitos"),
});

export type UpdateUserFormData = z.infer<typeof updateUserSchema>;
